<template>
    <div class="du_bid_management">
      <!--得物出价头部-->
      <div class="du_bid_mag_top">
        <div>
          <el-select v-model="selectStore" placeholder="请选择">
            <el-option
              v-for="item in storeList"
              :key="item.Id"
              :label="item.ShopName"
              :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div>
          <input v-model="numId" type="text" maxlength="30" placeholder="链接ID">
        </div>
        <div>
          <input v-model="goodsId" type="text" maxlength="30" placeholder="货号">
        </div>
          <span>最新出价时间</span>
        <div class="w_percent11">
          <el-date-picker
            v-model.trim="startTime"
            type="datetime"
            placeholder="年/月/日"
            format="yyyy/MM/dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div class="w_percent11">
          <el-date-picker
            v-model.trim="endTime"
            type="datetime"
            placeholder="年/月/日"
            format="yyyy/MM/dd HH:mm:ss">
          </el-date-picker>
        </div>
        <button class="btn_normal w116 ml5" @click="loadDewuPricePageListBtn()">查询</button>
        <button class="btn_normal w116 ml5 publish_btn" @click="ctrlBtn('duBidPublish', 'duBidPublish', '发布出价')">+发布出价</button>
        <button class="btn_normal w150 ml5" @click="ctrlBtn('batchCancel', checkboxModel, '批量取消出价')">取消所有出价</button>
        <button class="btn_normal w150 ml5" @click="exportDewuPriceExcel()">导出查询结果</button>
        <button class="btn_normal ml5 publish_btn" style="width: 172px;" @click="downAllPlatBidPrice()">获取平台所有出价</button>
      </div>
      <!--得物出价列表-->
      <div class="du_bid_mag_list">
        <!--表格-->
        <table class="table">
          <thead>
          <tr>
            <th><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
            <th>店铺名称</th>
            <th>链接ID</th>
            <th>货号</th>
            <th>零售价</th>
            <th>最新出价</th>
            <th>最新出价时间</th>
            <th>最后编辑人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody v-if="list.length">
          <tr v-for="(item, index) in list" :key="index">
            <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
            <td>{{item.ShopName}}</td>
            <td>{{item.NumId}}</td>
            <td>{{item.GoodsId}}</td>
            <td>{{item.SellPrice}}</td>
            <td>{{item.NewPrice}}</td>
            <td>{{item.EditeTime}}</td>
            <td>{{item.EdterName}}</td>
            <td>
              <a title="编辑" @click="ctrlBtn('duBidPublish', item.NumId, '发布出价')">编辑</a>
              <a title="链接出价详情" @click="toGetDewuPriceDetailList(item.NumId)">链接出价详情</a>
              <a title="取消所有出价" @click="toCancelDewuPrice(item.NumId)">取消所有出价</a>
              <a title="操作日志" @click="toDewuPriceLog(item.PriceId, item.NumId)">操作日志</a>
            </td>
          </tr>
          </tbody>
          <tbody v-if="!list.length">
          <tr>
            <td colspan="8">暂时没有相关的数据</td>
          </tr>
          </tbody>
        </table>

        <!--分页-->
        <div v-if="list.length" class="text_right mt20">
          <el-pagination
            background
            :prev-text="'上一页'"
            :next-text="'下一页'"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <!--弹出框-->
      <du-bid-management-embed-msg v-if="isShow" :title="dialogTitle" :msg="msg"
                                   :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></du-bid-management-embed-msg>

      <!--提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeTipsDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
    </div>
</template>

<script type="es6">
  import DuBidManagementEmbedMsg from './du-bid-management-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: "du-bid-management",
    components: {DuBidManagementEmbedMsg, LoadingDialog, MsgDialog},
    watch: { // 深度watch
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
        if (!this.checkboxModel.length) {
          this.checkAll = false;
        }
      } // 单选
    },
    data() {
      return {
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        list: [],  // 列表
        storeList: [], // 店铺
        selectStore: '', // 选择的店铺
        numId: null, // 链接ID
        goodsId: null, // 货号
        startTime: this.Global.timeFormatStart(new Date(new Date() - 1000 * 60 * 60 * 24 * 15)), // 开始时间
        endTime: this.Global.timeFormatEnd(new Date()), // 结束时间
        isLoading: false, // 是否显示加载框isErrorTxt
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        isShow: false, // 提示框显示
        msg: null, // 父子组件互传的数据
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 20 // 总条数
      }
    },
    methods: {
      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 获取店铺下拉框信息
      getDewuShopList() {
        this.$axios.post(this.Global.getDewuShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].Id;
              this.loadDewuPricePageList();
            } else {
              this.storeList = res.data.resData;
              this.selectStore = '';
            }
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 得物出价 导出查询结果
      exportDewuPriceExcel() {
        this.isLoading = true;
        const params = {
          ShopId: this.selectStore,
          NumId: this.numId,
          GoodsId: this.goodsId,
          StartTime: this.Global.timeFormatEight(this.startTime),
          EndTime: this.Global.timeFormatEight(this.endTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.exportDewuPriceExcel, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 得物出价 分页数据
      loadDewuPricePageList() {
        this.isLoading = true;
        const params = {
          ShopId: this.selectStore,
          NumId: this.numId,
          GoodsId: this.goodsId,
          StartTime: this.Global.timeFormatEight(this.startTime),
          EndTime: this.Global.timeFormatEight(this.endTime),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadDewuPricePageList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            if (res.data) {
              clearTimeout(timer);
              self.checkAll = false;
              self.checkboxModel = [];
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                res.data.resData.DataList.forEach(function(item, index) {
                  self.checkboxModel.push(false);
                })
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 得物出价 分页数据 查询按钮
      loadDewuPricePageListBtn() {
        this.currentPage = 1;
        this.loadDewuPricePageList();
      },

      // 批量取消选择链接的所有出价
      batchCancelDewuPriceByNumId() {

      },

      // 获取平台所有出价
      downAllPlatBidPrice() {
        this.isLoading = true;
        this.$axios.post(this.Global.downAllPlatBidPrice(this.selectStore)).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            if (res.data) {
              clearTimeout(timer);
              if (!res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '获取成功';
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 通过链接Id 获取得物出价详情
      toGetDewuPriceDetailList(numID) {
        this.isShow = true;
        this.dialogShowType = 'duBidDetail';
        this.msg = {
          shopId: this.selectStore,
          numId: numID
        };
        this.dialogTitle = '链接出价详情';
      },

      // 取消选择链接的所有出价
      toCancelDewuPrice(numID) {
        this.isShow = true;
        this.dialogShowType = 'duBidCanceled';
        this.msg = {
          shopId: this.selectStore,
          numId: numID
        };
        this.dialogTitle = '提示';
      },

      // 获取得物链接出价的日志
      toDewuPriceLog(priceId, numID) {
        this.isShow = true;
        this.dialogShowType = 'duBidLog';
        this.msg = {
          shopId: priceId,
          numId: numID
        };
        this.dialogTitle = '操作日志';
      },

      // 操作按钮
      ctrlBtn(type, announceMsg, title) {
        if (type === 'batchCancel') {
          if (this.checkboxModel.indexOf(true) === -1) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要取消的链接';
          } else {
            const msgList = {shopId: this.selectStore, numIdList: []};
            announceMsg.forEach((v, i) => {
              if (v) {
                msgList.numIdList.push(this.list[i].NumId);
              }
            });
            this.msg = msgList;
            this.isShow = true;
            this.dialogShowType = type;
            this.dialogTitle = title;
          }
        } else if (type === 'duBidPublish') {
          if (announceMsg !== 'duBidPublish') {
            this.msg = announceMsg;
          } else {
            this.msg = null;
          }
          this.isShow = true;
          this.dialogShowType = type;
          this.dialogTitle = title;
        } else {
          this.isShow = true;
          this.dialogShowType = type;
          this.dialogTitle = title;
        }
        // this.announceMsg = announceMsg;
        // this.noticeId = announceMsg;
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.issuc && e.showType === 'duBidPublish' || e.showType === 'duBidCanceled') {
          this.loadDewuPricePageList();
        }
      },

      // 关闭提示框
      closeTipsDialog(e) {
        this.isMsg = e;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        if (val < this.checkboxModel.length) {
          this.checkboxModel = this.checkboxModel.splice(0, val);
        }
        this.loadDewuPricePageList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.checkboxModel = [];
        this.loadDewuPricePageList();
      }
    },
    created() {
      this.getDewuShopList();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .du_bid_management {
    .du_bid_mag_top {
      & > div {
        max-width: 160px;
        margin-right: 5px;
      }

      .publish_btn {
        width: 125px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/du-bid-management.vue